import { Facebook, Linkedin, Mail } from "lucide-react";
import { Link } from "react-router-dom";

// Brand icons not shipped by lucide — hand-rolled inline SVGs sized to match.
const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.66a8.16 8.16 0 0 0 4.77 1.52V6.73a4.85 4.85 0 0 1-1.84-.04Z" />
  </svg>
);

const SnapchatIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M12.02 2c3.3-.03 5.72 2.6 5.72 5.9 0 .74-.08 1.43-.14 2 .27.14.66.28 1.05.28.5 0 .96-.2 1.29-.32.2-.08.4-.14.55-.14.36 0 .95.2 1.02.83.05.5-.31.83-.9 1.08-.19.08-.4.14-.61.2-.66.2-1.44.44-1.65.94-.11.26-.06.6.14.99v.02c.02.05 1.71 3.78 5.18 4.35.28.05.48.29.47.58 0 .07-.02.15-.05.23-.24.55-1.24.96-3.06 1.24-.05.09-.13.4-.17.6-.05.19-.09.4-.15.6-.09.29-.28.43-.6.43h-.03c-.16 0-.36-.03-.63-.08-.43-.09-.87-.14-1.31-.14-.85 0-1.42.09-2.13.62-.83.62-1.86 1.4-3.3 1.4l-.13-.01h-.14c-1.44 0-2.47-.78-3.3-1.4-.7-.53-1.28-.62-2.13-.62-.44 0-.88.05-1.31.14-.27.05-.47.08-.63.08-.32 0-.51-.14-.6-.43-.06-.2-.1-.41-.15-.6-.04-.2-.12-.51-.17-.6-1.82-.28-2.82-.69-3.06-1.24a.68.68 0 0 1-.05-.23c-.01-.29.19-.53.47-.58 3.47-.57 5.16-4.3 5.18-4.35v-.02c.2-.4.25-.73.14-.99-.21-.5-.99-.74-1.65-.94-.21-.06-.42-.12-.61-.2-.72-.28-.94-.61-.89-1.11.05-.5.45-.83.94-.83.14 0 .34.05.55.14.33.13.79.32 1.29.32.4 0 .78-.14 1.05-.28-.06-.57-.14-1.26-.14-2 0-3.3 2.42-5.93 5.72-5.9Z" />
  </svg>
);

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-hairline py-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
        <div className="flex items-center gap-4">
          <img
            src="/w-logo-navy.png"
            alt="W"
            className="h-8 w-8 object-contain opacity-80 dark:hidden"
            data-testid="footer-logo"
          />
          <img
            src="/w-logo.png"
            alt=""
            aria-hidden="true"
            className="h-8 w-8 object-contain opacity-80 hidden dark:block invert"
          />
          <p className="font-mono-label text-[11px] tracking-[0.22em] uppercase text-ash">
            © 2026 Sitemapp, Inc. All rights reserved.
          </p>
        </div>

        <div className="flex items-center gap-5 sm:gap-6">
          <Link
            to="/privacy"
            data-testid="footer-privacy-link"
            className="font-mono-label text-[11px] tracking-[0.22em] uppercase text-ash hover:text-pearl transition-colors"
          >
            Privacy
          </Link>
          <div className="flex items-center gap-4">
            <a
              href="mailto:hello@w.xyz"
              aria-label="Email W support"
              data-testid="footer-contact-link"
              className="text-ash hover:text-pearl transition-colors"
            >
              <Mail className="w-4 h-4" />
            </a>
            <a
              href="https://fb.com/wdotxyz"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="W on Facebook"
              data-testid="footer-facebook-link"
              className="text-ash hover:text-pearl transition-colors"
            >
              <Facebook className="w-4 h-4" />
            </a>
            <a
              href="https://tiktok.com/@wdotxyz"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="W on TikTok"
              data-testid="footer-tiktok-link"
              className="text-ash hover:text-pearl transition-colors"
            >
              <TikTokIcon className="w-4 h-4" />
            </a>
            <a
              href="https://snapchat.com/add/wdotxyz"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="W on Snapchat"
              data-testid="footer-snapchat-link"
              className="text-ash hover:text-pearl transition-colors"
            >
              <SnapchatIcon className="w-4 h-4" />
            </a>
            <a
              href="https://linkedin.com/company/sitemapp"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="W on LinkedIn"
              data-testid="footer-linkedin-link"
              className="text-ash hover:text-pearl transition-colors"
            >
              <Linkedin className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
